// src/lib/calculate-result.ts
// ZENTRALE RESULT-BERECHNUNG: Nutzt NUR V3 Master Engine

import { buildMasterResult, type MasterResult } from './master-engine';
import { buildEngineInput } from './master-engine-input';

export function calculateAuditResult(
  rawAnswers: Record<string, unknown>,
  companyProfile: {
    companyName?: string;
    industry?: string;
    businessModel?: string;
    teamSize?: string | number;
    acquisitionMethods?: Record<string, number>;
    funnelData?: {
      monthlyContacts?: number;
      monthlyDiscoveryCalls?: number;
      monthlyPresentations?: number;
      monthlyDeals?: number;
      averageDealSize?: number;
      monthlyRevenue?: number;
      salesCycleMonths?: number;
      responseTime?: string;
      followUpDiscipline?: string;
      pipelineTransparency?: string;
      leadQuality?: string;
    };
  }
): MasterResult {
  // Build engine input from raw data
  const engineInput = buildEngineInput(rawAnswers, {
    companyName: companyProfile.companyName,
    industry: companyProfile.industry,
    businessModel: companyProfile.businessModel,
    teamSize: companyProfile.teamSize,
    acquisitionMethods: companyProfile.acquisitionMethods,
    funnelData: companyProfile.funnelData,
  });

  // V3 Master Engine rechnet ALLES
  const masterResult = buildMasterResult(engineInput);

  return masterResult;
}